module.exports = __webpack_public_path__ + "static/media/icon_tenancy.ad06b0df.svg";